import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { TeamModel } from 'projects/core/src/lib/models/team.model';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { HelperService } from 'projects/admin/src/app/services/helper.service';

@Component({
  selector: 'app-team-detail',
  templateUrl: './team-detail.component.html',
  styleUrls: ['./team-detail.component.scss']
})
export class TeamDetailComponent extends BaseDetail implements OnInit {

  public team: TeamModel = null;
  public backRoute = ['/teams'];

  constructor(
    protected ui: UiService,
    protected router: Router,
    private api: ApiService,
    private route: ActivatedRoute,
    protected helper: HelperService,
    public transloco: TranslocoService
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        this.api.getModel('teams', params.id).subscribe({
          next: (result: any) => {
            this.team = new TeamModel().deserialize(result.data);
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

}
